import { render, staticRenderFns } from "./care-partners-activities.vue?vue&type=template&id=13736ff3&"
import script from "./care-partners-activities.vue?vue&type=script&lang=js&"
export * from "./care-partners-activities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports